import { Typography, type TypographyProps } from '@mui/material';
import { Link } from '~/components/Link';

interface LogoPoweredByLinkProps extends TypographyProps {}
export const LogoPoweredByLink = ({
  ...TypographyProps
}: LogoPoweredByLinkProps) => {
  return (
    <Typography variant="caption" {...TypographyProps}>
      Logos provided by{' '}
      <Link
        href={'https://logo.dev/?utm_source=www.nerdydata.com'}
        rel="noopener nofollow"
        target="_blank">
        Logo.dev
      </Link>
    </Typography>
  );
};
